<template>
    <div class="col-md-7 col-lg-8 col-xl-9">
        <div class="ctr-details my-5">
            <div class="top-section">
                <div class="img-wrapper">
                <input
                    type="file"
                    class="sr-only"
                    ref="companyLogoFileInput"
                    @change="uploadCompanyLogo"
                />
                <img
                    v-if="contractor_details.active_business.logo_url"
                    :src="contractor_details.active_business.logo_url"
                    alt="Company Logo"
                    height="100px"
                />
                </div>

                <div class="right-content ml-md-4">
                    <h1 class="ctr-details">
                        {{ contractor_details.active_business.company_name }}<br />
                        <span>{{ contractor_details.full_name }}</span>
                    </h1>

                    <p class="mt-3">
                            {{contractor_details.active_business.phone}}
                        <br />
                        <span>{{ contractor_details.active_business.address }}</span>
                    </p>

                    <ul class="review-star">
                        <li
                        v-for="(n, idx) in Math.floor(
                            contractor_details.active_business.ratings
                        )"
                        :key="'rat-fas-' + idx"
                        >
                        <i class="fas fa-star"></i>
                        </li>

                        <li
                        v-for="(n, idx) in 4 -
                        Math.floor(contractor_details.active_business.ratings)"
                        :key="'rat-fas-' + idx"
                        >

                        <i class="fas fa-star checked"></i>
                        </li>

                        <li><i class="far fa-star"></i></li>
                        <li><span class="review-count">{{ contractor_details.active_business.ratings_count }} Reviews</span></li>
                    </ul>
                </div>
            </div>

            <div class="ctr-tags">
                <ul class="type-btn">
                    <li
                    v-for="category in contractor_details.active_business.categories"
                    :key="'cat-' + category.id"
                    >
                    <button type="button" class="btn btn-secondary">
                                            <i class="fas fa-tag mr-2"></i>{{ category.name }}
                    </button>
                    </li>
                </ul>
            </div>
        </div>

        <job-history></job-history>
  </div>
</template>


<script>
import phoneNoMixin from "@mixins/phoneNoMixin.js";
import JobHistory from '@frontend/pages/manager/contacts/Contractors/view/JobHistory.vue';


export default {
    components: {
        JobHistory
    },
  data() {
    return {
      contractor_details: {
        active_business: {
          logo_url: "",
        },
      },
    };
  },
  mixins: [phoneNoMixin],
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
       this.$root.$data.bsLoader = true;
      axios.post("api/manager/contacts/contractor/getDetails", {
        load_active_business: true,
        load_active_business_logo: true,
        load_active_business_categories: true,
        contractor_id: this.$route.params.id,
      }).then((response) => {
        this.contractor_details = response.data.contractor_details;
        this.contractor_details.active_business.logo_url = response.data.logo_url ? response.data.logo_url : this.$root.serverBasePath + '/notavailabeimage.jpg';
        this.contractor_details.active_business.phone = response.data.contractor_details.active_business.business_phone?.toString()?.replace(/(\d{1,4})(\d{1,3})(\d{1,3})/g, '$1 $2 $3');
         this.$root.$data.bsLoader = false;
      }).catch((error) => {
         this.$root.$data.bsLoader = false;
      });
    },
    uploadCompanyLogo(event) {
      if (!event.target.files.length) return;

      let formData = new FormData();
      formData.append("logo", event.target.files[0]);

      axios
        .post("api/contractor/compliance/uploadLogo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.contractor_details.active_business.logo_url = response.data.logo_url;
        });
    },
  },
};
</script>

<style scoped>
.top-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
}

@media screen and (max-width: 767px) {
    .top-section {
        justify-content: center;
    }
}
</style>